module.exports = __webpack_public_path__ + "img/logo-lg-light.b0131770.svg";